module.exports = __webpack_public_path__ + "img/logo.b3623d9.svg";